import {MonitoringServiceType, ScheduleState} from "@/lib/types/checks.ts";
import {ReactNode} from "react";

export enum ServiceField {
  INTERVAL = "msp_interval",
  ADDRESS = "msp_address",
  URL_SCHEME = "msp_url_scheme",
  URL_PATH = "msp_url_path",
  PORT = "msp_port",
  USERNAME = "msp_username",
  PASSWORD = "msp_password",
  PROXY = "msp_proxy",
  DNS_SERVER = "msp_dns_server",
  DNS_RECORD_TYPE = "msp_dns_record_type",
  STATUS_CODE = "msp_status_code",
  SEND_STRING = "msp_send_string",
  EXPECT_STRING = "msp_expect_string",
  EXPECT_STRING_TYPE = "msp_expect_string_type",
  ENCRYPTION = "msp_encryption",
  THRESHOLD = "msp_threshold",
  HEADERS = "msp_headers",
  SCRIPT = "msp_script",
  VERSION = "msp_version",
  SENSITIVITY = "msp_sensitivity",
  NUM_RETRIES = "msp_num_retries",
  USE_IP_VERSION = "msp_use_ip_version",
  UPTIME_SLA = "msp_uptime_sla",
  RESPONSE_TIME_SLA = "msp_response_time_sla",
  NOTES = "msp_notes",
  INCLUDE_IN_GLOBAL_METRICS = "msp_include_in_global_metrics",
  GROUP_CHECK_TAGS = "group_check_tags",
  GROUP_CHECK_SERVICES = "group_check_services",
  GROUP_CHECK_DOWN_CONDITION = "group_check_down_condition",
  GROUP_UPTIME_PERCENT_CALCULATION = "group_uptime_percent_calculation",
  GROUP_RESPONSE_TIME_CALCULATION_MODE = "group_response_time_calculation_mode",
  GROUP_RESPONSE_TIME_CHECK_TYPE = "group_response_time_check_type",
  GROUP_RESPONSE_TIME_SINGLE_CHECK = "group_response_time_single_check",
  SSL_CRL = "ssl_cert_crl",
  SSL_FIRST_ELEMENT = "ssl_cert_first_element_only",
  SSL_MATCH = "ssl_cert_match",
  SSL_ISSUER = "ssl_cert_issuer",
  SSL_RESOLVE = "ssl_cert_resolve",
  SSL_MIN_VERSION = "ssl_cert_minimum_ssl_tls_version",
  SSL_FINGERPRINT = "ssl_cert_fingerprint",
  SSL_SELFSIGNED = "ssl_cert_selfsigned",
  SSL_FILE = "ssl_cert_file",
  SSL_PROTOCOL = "ssl_cert_protocol",
  SSL_IGNORE_AUTHORITY_WARNINGS = "ssl_ignore_authority_warnings",
  SSL_IGNORE_SCT = "ssl_ignore_sct",
  PAGESPEED_EXCLUDE_URLS = "exclude_urls",
  PAGESPEED_EMULATED_DEVICES = "emulated_device",
  PAGESPEED_CONNECTION_THROTTLING = "connection_throttling",
  PAGESPEED_GRADE_THRESHOLD = "uptime_grade_threshold",
  RUM_APDEX_THRESHOLD = "apdex_threshold",
  RUM_AGGREGATION_TYPE = "aggregation_type",
  RUM_EXCLUDE_USER_AGENTS = "exclude_useragents",
  RUM_EXTERNAL_DOMAINS = "external_domains",
  RUM_URL_GROUPS = "url_groups",
  RUM_EXCLUDE_GROUP_PARAMS = "exclude_get_params",
  RUM_IS_AJAX_DISABLED = "is_ajax_disabled",
  FTP_PATHS = "ftp_paths",
  FTP_SKIP_CERT_VERIFICATION = "ftp_skip_cert_verification",
  FTP_EXPLICIT_TLS = "ftp_explicit_tls",
  SFTP_PRIVATE_KEY = "sftp_private_key",
  SFTP_PASSPHRASE = "sftp_passphrase",
  SFTP_KNOWN_HOSTS = "sftp_known_hosts",
  CLOUD_STATUS = "cloud_status",
  NOTIFY_ONLY_ON_DOWN = "notify_only_on_down",
  THIRD_PARTY_GROUP = "third_party_group",
  THIRD_PARTY_COMPONENTS = "third_party_components",
  THIRD_PARTY_MONITORING_TYPE = "third_party_monitoring_type",
  // extra service fields not defined in service def
  LOCATION = "monitoring_groups",
  CONTACT_GROUPS = "contact_groups",
  TAGS = "tags",
  NAME = "name",
  ID = "id",
  SCHEDULE_STATE = "schedule_state",
  ESCALATIONS = "escalations",
  SCHEDULE_ENTRIES = "schedule_entries",
  IS_UNDER_MANUAL_MAINTENANCE = "is_under_manual_maintenance",
  PAUSE_UNDER_MANUAL_MAINTENANCE = "pause_under_manual_maintenance",
  MAINTENANCE_SCHEDULE_IDS = "maintenance_schedule_ids",
  GLOBAL_PING_NETWORK_LOCATIONS = "network_locations",
  GLOBAL_PING_NETWORK_NAME = "network_name",
  GLOBAL_PING_NETWORK_CAPTURE_TRACEROUTE = "network_capture_traceroute",
  GLOBAL_PING_NETWORK_NO_PROBE_FALLBACK = "network_no_probe_fallback",
}

export const SCHEDULE_STATE_TITLE: Record<ScheduleState, string> = {
  [ScheduleState.ACTIVE]: "No maintenance window",
  [ScheduleState.SUPPRESSED]: "Under maintenance now",
  [ScheduleState.SCHEDULED]: "Use maintenance schedule",
};

export const SCHEDULE_STATE_DESC: Record<ScheduleState, string | ReactNode> = {
  [ScheduleState.ACTIVE]: "Alerts will be sent normally.",
  [ScheduleState.SUPPRESSED]: "Alerts will be suppressed until you change this setting.",
  [ScheduleState.SCHEDULED]: "Alerts will be suppressed based on the following schedule.",
};

export const AutoLocationServiceTypes = [
  MonitoringServiceType.PAGESPEED,
  MonitoringServiceType.SSL_CERT,
  MonitoringServiceType.WHOIS,
  MonitoringServiceType.RDAP,
  MonitoringServiceType.BLACKLIST,
  MonitoringServiceType.MALWARE,
];
